<template>
  <section class="details-section">
    <img class="mb-4 h-16 w-auto m-auto" :src="team.companyLogo" />
    <template v-if="!rescheduling">
      <CardTitle>{{ team.name }} - {{ team.eventName }}</CardTitle>
      <p class="mt-4 text-sm leading-6 text-muted-foreground">{{ team.eventDescription }}</p>
    </template>
    <template v-else>
      <CardTitle>Reschedule {{ existingEvent.eventName }}</CardTitle>
      <p class="mt-4 text-sm leading-6 text-muted-foreground">
        Existing event - {{ formatDate(existingEvent.startTime, 'MMMM dd, yyyy') }}
        {{ formatDate(existingEvent.startTime, 'h:mm a') }} -
        {{ formatDate(existingEvent.endTime, 'h:mm a') }}
      </p>
    </template>
  </section>
</template>

<script setup lang="ts">
import { CardTitle } from '@/components/ui/card';
import DateUtility from '../../utilities/dates';

defineProps<{
  team: {
    companyLogo: string;
    name: string;
    eventName: string;
    eventDescription: string;
  };
  existingEvent: {
    eventName: string;
    startTime: string;
    endTime: string;
  };
  rescheduling: boolean;
}>();

const { formatDate } = DateUtility;
</script>

<style scoped>
@reference 'tailwindcss';

.details-section {
  @apply md:col-span-12 mb-12 lg:mb-0 lg:col-span-4 mt-12 md:mt-0 md:pr-14;
}
</style>
